module.exports = __webpack_public_path__ + "static/media/avatar-promotions.0415f721.png";